import "./TwoFactor.scss"

import { FooterVariant, InputButton } from "@skylead/component-library"
import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { ONE_TIME_PASSWORD_NUMBER_INPUTS } from "../../../constants/two-factor-constants"
import { twoFactorAuthSetup } from "../../../redux/actions"
import { disable2FAModal } from "../../../utils/2fa-utils"
import { useGlobalTranslation } from "../../../utils/hook"
import LangText from "../LangText"
import ModalWrapper from "../ModalWrapper"
import OTPInput from "../OTPInput"
import QRCodeGenerator from "../QRCodeGenerator"

const TwoFactor = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { tt } = useGlobalTranslation()

  const { otpUri, secret, totpToken } = useSelector(state => ({
    otpUri: state.user.twoFactor.otpUri,
    secret: state.user.twoFactor.secret,
    totpToken: state.forms.formData.totpToken,
  }))

  const twoFactorSetup = async () => {
    const result = await dispatch(twoFactorAuthSetup(tt, totpToken, navigate))

    if (result) {
      const currentUrl = window.location.href
      const updatedUrl = currentUrl.replace(/[?&]twoFactorAuth=true/, "")
      window.history.replaceState({}, document.title, updatedUrl)
      disable2FAModal(tt)
    }
  }

  return (
    <ModalWrapper
      footerVariant={FooterVariant.TRANSACTIONAL}
      primaryBtn={{
        label: tt("submit"),
        onClick: twoFactorSetup,
        disabled: totpToken?.length !== ONE_TIME_PASSWORD_NUMBER_INPUTS,
      }}
      secondaryBtn={{ label: tt("cancel") }}
    >
      <div className="two-factor">
        <div className="two-factor__setting">
          <div className="two-factor__name-and-description">
            <span className="large">
              <LangText langKey="two.factor.step.1.label" />
            </span>
            <span className="small">
              <LangText langKey="two.factor.step.1.msg" />
            </span>
          </div>
          <div className="two-factor__control">
            <idv>
              <div className="qr-code__image">
                <QRCodeGenerator value={otpUri} size={200} />
              </div>
            </idv>
            {secret && (
              <div className="two-factor__title">
                <span className="large-bold">{secret}</span>
                <InputButton icon="copy-20" onClick={() => navigator.clipboard.writeText(secret)} />
              </div>
            )}
          </div>
        </div>

        <div className="two-factor__setting">
          <div className="two-factor__name-and-description">
            <span className="large">
              <LangText langKey="two.factor.step.2.label" />
            </span>
            <span className="small">
              <LangText langKey="two.factor.step.2.msg" />
            </span>
          </div>
          <div className="two-factor__container">
            <OTPInput />
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}

export default TwoFactor
